/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterViewModel } from '../../models/work-center-view-model';

export interface GetWorkCenterById$Params {
  workCenterId: number;
}

export function getWorkCenterById(http: HttpClient, rootUrl: string, params: GetWorkCenterById$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterViewModel>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterById.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterViewModel>;
    })
  );
}

getWorkCenterById.PATH = '/api/v1/WorkCenter/GetWorkCenterById/{workCenterId}';
